$(()=>{
  let valid ;
  let arrInclusionA = [];
  let arrInclusionB = [];
  
  let allArr =[];

  inclusionVariant();
  let objInclusionA = {
     'inclusions':'',
     'texture':'',
     'optional':'',
     'design':'',
     'ashes':'',
     'other':'',
     'engraved':'',
     'engraved_item': false,
  };
  let objInclusionB = {
     'inclusions':'',
     'texture':'',
     'optional':'',
     'design':'',
     'ashes':'',
     'other':'',
     'engraved':'',
     'engraved_item': false,
  };



    function unDisableCustomSelectCheckbox(container){
       $(`${container} .inclusion__checkboxs .check-select-items .check-item`).each(function(){
           
             $(this).find('input').prop( 'disabled', false );
           
       });
     }
     function disableCustomSelectCheckbox(container){
       $(`${container} .inclusion__checkboxs .check-select-items .check-item`).each(function(){
           if( !$(this).find('input').is(':checked')){
             $(this).find('input').prop( 'disabled', true );
           }
       });
     }
     function changeVariantInclusion(l,container){
       console.log('length:', l);
       
       if( l == 3){
           disableCustomSelectCheckbox(container);
       }else{
           unDisableCustomSelectCheckbox(container);
       }
 
 
       
     }
    
    function inclusionVariant(){
      allArr = [];
      console.log(arrInclusionA);
       console.log(arrInclusionB);
       
      allArr = [...arrInclusionA,...arrInclusionB];
      let lengthArr = allArr.length;
      console.log(allArr, lengthArr);
       switch (lengthArr) {
         case 0:
            $('.select-inclusion').val('one inclusion');
             
            console.log('xd');
            break;
          case 1:
            $('.select-inclusion').val('one inclusion');
          
            break;
          case 2:
            $('.select-inclusion').val('two inclusions');
           
            break;
           case 3:
            $('.select-inclusion').val('three inclusions');
          
            break;
           case 4:
            $('.select-inclusion').val('four inclusions');
          
            break;
           case 5:
            $('.select-inclusion').val('five inclusions');
          
            break;
           case 6:
            $('.select-inclusion').val('six inclusions');
          
            break;
          default:
            console.log(`Sorry, we are out of ${lengthArr}.`);
        }
        //$('variant-selects')[0].onVariantChange();
        let timePrice = setInterval(() =>{
          addNewPrice();
        }, 0);

        setTimeout(() => { clearInterval(timePrice);}, 5000);
       
   
    }
   
 
  /***** When the checkbox select changes '.check-item' ****/
   function SelectCheckboxChage(obj,arr,element,container,containerNull){
     arr = [];
    
         nullElement(containerNull,obj);
         $(element).each(function(){
             if($(this).find('input').is(':checked')){
                
                 arr.push($(this).find('input').val().toLowerCase());
             }
         });
         changeVariantInclusion(arr.length,container);
         if(arr.length > 0){
             let str = arr.join(',');
             $(`${container} .inclusion__checkboxs .select__wrap`).find('.select-item-name h6').text(str);
             $(`${container} .inclusion__checkboxs`).find('.select__wrap').addClass('active');
             obj.inclusions = str;
            
         }else{
             $(`${container} .inclusion__checkboxs .select__wrap`).find('.select-item-name h6').text('Choose your Inclusions');
             $(`${container} .inclusion__checkboxs`).find('.select__wrap').removeClass('active');
             obj.inclusions = '';
         }
        console.log(arrInclusionA);
        elementSearch(arr,container,obj);
        
        return arr;
   }
  /***** object zeroing ***/
  
     function nullObj(obj){
         obj.optional = '';
         obj.texture = '';
         obj.design = '';
         obj.ashes = '';
         obj.other = '';
         obj.engraved = '';
         obj.engraved_item = false;
     }

    function nullElement(container,obj){
         $(container).each(function(){
             $(this).removeClass('active');
             $(this).find('.select__name').text($(this).find('.select__option').first().text());
             $('.select__wrap').find('textarea').val('');
         });
         nullObj(obj);
         
     }
    function elementShowOptional(container,obj,el1=0, el2=0,el3=0){
         
        
         if(el1 !='' && arguments.length == 3){
             
             someShowItems([`${container} .select__wrap[data-item="optional"]`]);  
         }else if(el1 != '' && el2 != '' && arguments.length == 4){
             
             someShowItems([`${container} .select__wrap[data-item="optional"]`]);  
         }else if(el1 != '' && el2 != '' && el3 != '' && arguments.length == 5){
           
             someShowItems([`${container} .select__wrap[data-item="optional"]`]);  
         }else{
            
             obj.optional = '';
        
             $(container + ' .select__wrap[data-item="optional"] input').each(function(){
                      $(this).prop('checked', false);
              });
             $(container + ' .select__wrap[data-item="optional"] .select-item-name').find('h6').text('free add on (Optional)');
             $(container + ' .select__wrap[data-item="optional"]').removeClass('active');
             $(`${container} .select__wrap[data-item="optional"]`).addClass('hidden');
         }
       
     }
    function allElementHide(container){
         $(container).find('.select__wrap').addClass('hidden');
         $('.inclusion__checkboxs .select__wrap').removeClass('hidden');  
    }

     function someShowItems(arr){
     
         arr.forEach(el => {
             
             $(el).removeClass('hidden')
         });
     }
    function elementSearch(arr, container, obj){
          console.log(arr);
         let bol = arr.length > 0 ? true : false;
         
          
         
         if(bol){
           console.log(8);
          
             if(arr.includes('breastmilk') &&  !arr.includes('ashes') && !arr.includes('other')){
                
                 allElementHide(container);
                 someShowItems([ `${container} .select__wrap[data-item="texture"]`]);
                 console.log(obj.texture);
                 elementShowOptional(container, obj, obj.texture);
         
             }else if( !arr.includes('breastmilk') &&  arr.includes('ashes') && !arr.includes('other')){
                
                 allElementHide(container);
                 someShowItems([`${container} .select__wrap[data-item="ashes"]`]);
                 elementShowOptional(container, obj ,obj.ashes);
             }else if( !arr.includes('breastmilk') &&  !arr.includes('ashes') && arr.includes('other')){
                 console.log('zachel 3')
                 allElementHide(container);
                 someShowItems([`${container} .select__wrap[data-item="other"]`]);
                 elementShowOptional(container, obj, obj.other);
             }else if( arr.includes('breastmilk') &&  arr.includes('ashes') && !arr.includes('other')){
                 
                 allElementHide(container);
                 someShowItems([`${container} .select__wrap[data-item="texture"]`,`${container} .select__wrap[data-item="ashes"]`]);
                 elementShowOptional(container,obj,obj.ashes ,obj.texture); 
             }else if( arr.includes('breastmilk')  && arr.includes('other') &&  !arr.includes('ashes')){
                
                 allElementHide(container);
                 someShowItems([`${container} .select__wrap[data-item="texture"]`,`${container} .select__wrap[data-item="other"]`]);    
                 elementShowOptional(container,obj,obj.texture ,obj.other);  
                 
             }else if( arr.includes('ashes') && arr.includes('other') && !arr.includes('breastmilk')){
                
                 allElementHide(container);
                 someShowItems([`${container} .select__wrap[data-item="ashes"]`,`${container} .select__wrap[data-item="other"]`]);   
                 elementShowOptional(container,obj,obj.ashes, obj.other);   
          
             }else{
                
                 obj.optional = '';
                 $(container + ' .select__wrap[data-item="optional"] input').each(function(){
                      $(this).prop('checked', false);
                  });
                 $(container + ' .select__wrap[data-item="optional"] .select-item-name').find('h6').text('free add on (Optional)');
                 allElementHide(container);
                 someShowItems([`${container} .select__wrap[data-item="optional"]`]);  
             }

             
         }else{
             console.log(4);
             allElementHide(container);
             obj.inclusions = '';
             nullObj(obj);
          
             return
         }
         
       
             
     }
     function  changeOther(obj, item){
         obj.other = $(item).closest('.select__wrap').find('textarea').val();
        if( obj.other != ''){
               $(item).closest('.select__wrap').addClass('active');
        }else{
                 $(item).closest('.select__wrap').removeClass('active');
        }
     } 

     function changeOptional(obj,container,item,arr){
         let arrOptional = [];
          if($(item).hasClass('no-add')){
            $(container + ' .select__wrap[data-item="optional"] input:not(.no-add)').each(function(){
                        $(this).prop('checked', false);
            });
          }else{
            $(container + ' .select__wrap[data-item="optional"] input.no-add').prop('checked', false);
          }


       
         $(container + ' .select__wrap[data-item="optional"] .check-item').each(function(){
             if($(this).find('input').is(':checked')){
                  arrOptional.push($(this).find('input').val());
             }
         }); 
          console.log(arrOptional.length);
        if( arrOptional.length != 0){
           let str =  arrOptional.join(',');
           obj.optional = str;
           $(container + ' .select__wrap[data-item="optional"] .select-item-name h6').text(str.toUpperCase());
           $(container + ' .select__wrap[data-item="optional"]').addClass('active');
           someShowItems([`${container} .select__wrap[data-item="design"]`]);
           //showEngreved();
         }else if (arr.length > 1 ){
             someShowItems([`${container} .select__wrap[data-item="design"]`]);
         }else{
           obj.optional = '';
           $(container + ' .select__wrap[data-item="optional"] input').each(function(){
                    $(this).prop('checked', false);
            });
           $(container + ' .select__wrap[data-item="optional"] .select-item-name').find('h6').text('free add on (Optional)');
           $(container + ' .select__wrap[data-item="optional"]').removeClass('active');
           $('.select__wrap[data-item="design"]').addClass('hidden');
           obj.design = '';
           $(`${container} .select__wrap[data-item="design"]`).removeClass('active');
           $(`${container} .select__wrap[data-item="design"] .select__name`).text($(`${container} .select__wrap[data-item="design"] .select__option`).first().text());
       }
     }



   
     function addNewPrice(){
       let variantArr = [];
       let variantStr = '';
       $('.m_select').each(function(){
        variantArr.push($(this).val());
      });
       variantStr = variantArr.join(' / ');
       let charmPrice = +$('.vvid span[data-variant-name="'+ variantStr +'"]').attr('data-variant-price').replace(/[^+\d]/g, '');
       let priceVariant = +$('.price-item.price-item--regular').attr('data-price').replace(/[^+\d]/g, '');
       let incPrice1 = +$('.select-inclusion option:selected').attr('data-price').replace(/[^+\d]/g, '');
  
       let newPrice = charmPrice + priceVariant + incPrice1;
       $('.price-item--regular').text('$' + newPrice);
     }
  
    function charmChange(){
      let charmArr = [];
      let strCharm = '';
      $('.m_select').each(function(){
        charmArr.push($(this).val());
      });
 
      strCharm = charmArr.join(' / ');
      console.log(strCharm);
      let variantCharm =$('.vvid span[data-variant-name="'+ strCharm +'"]').attr('data-charm-variant-id');
      $('.form-charm .inclusion-variant').val(variantCharm);
      addNewPrice();
    }
    charmChange();
  $('.m_select').change(charmChange);
  $(document).on('change','.select [name="options[Metal]"], .select [name="options[Length]"]', ()=>{
       $('.inclusion__checkboxs .check-item').find('input').prop('checked',false);
       $('.inclusion__checkboxs .select-item-name h6').text('Choose your Inclusions');
        arrInclusionA = [];
        arrInclusionB = [];
       
        nullElement('[data-inclusions="A"] .select__wrap', objInclusionA);
        nullElement('[data-inclusions="B"] .select__wrap', objInclusionB);
        elementSearch(arrInclusionA, '[data-inclusions="A"]', objInclusionA);
        elementSearch(arrInclusionB, '[data-inclusions="B"]', objInclusionB);
        inclusionVariant();
        let timePrice = setInterval(() =>{
          addNewPrice();
        }, 0);

        setTimeout(() => { clearInterval(timePrice);}, 5000);
   });
   $('.inclusion__name').click(function(){
         $(this).closest('.inclusion__variant').toggleClass('active');
   });

   $('.inclusion__checkboxs .select__wrap').click(function(){
         $(this).find('.select-checkbox').toggleClass('active');
   }); 

   $(document).mouseup( function(e){ 
       $('.custom__select').each(function(){
         let div = $(this); 
         if ( !div.is(e.target) && div.has(e.target).length === 0 ) { 
             div.removeClass('active'); 
         }
       });
        
  });

  $('[data-inclusions="A"] .inclusion__checkboxs .check-item input').change(function(){
     arrInclusionA = SelectCheckboxChage(objInclusionA, arrInclusionA ,'[data-inclusions="A"] .inclusion__checkboxs .check-item','[data-inclusions="A"]','[data-inclusions="A"] .select__wrap');
       $('.inclusions .select__wrap').css('border','1px solid #FFFFFF');
         $('.inclusions .select__wrap.active').css('border','1px solid #CFA96A');
     inclusionVariant();
  }); 
  
  $('[data-inclusions="B"] .inclusion__checkboxs .check-item input').change(function(){
    arrInclusionB = SelectCheckboxChage(objInclusionB, arrInclusionB ,'[data-inclusions="B"] .inclusion__checkboxs .check-item','[data-inclusions="B"]','[data-inclusions="B"] .select__wrap');
      $('.inclusions .select__wrap').css('border','1px solid #FFFFFF');
         $('.inclusions .select__wrap.active').css('border','1px solid #CFA96A');
    inclusionVariant();
  });

  $('.select__name').click(function(){
         $(this).closest('.custom__select').toggleClass('active');
  });
  $('.custom__select .select__option').click(function(){
         let v = $(this).attr('value');
         if(v != ''){
             $(this).closest('.select__wrap').addClass('active');
             $(this).closest('.custom__select').find('.select__name').text(v);
         }else{
             $(this).closest('.select__wrap').removeClass('active');
             $(this).closest('.custom__select').find('.select__name').text($(this).text());
         }
         $('.inclusions .select__wrap').css('border','1px solid #FFFFFF');
         $('.inclusions .select__wrap.active').css('border','1px solid #CFA96A');
  });


  $('[data-inclusions="A"] .select__wrap[data-item="texture"] .select__option').click(function(){
       
        objInclusionA.texture = $(this).attr('value');
        console.log(arrInclusionA);
        elementSearch(arrInclusionA, '[data-inclusions="A"]', objInclusionA);
  });
  
  $('[data-inclusions="B"] .select__wrap[data-item="texture"] .select__option').click(function(){
         objInclusionB.texture = $(this).attr('value');
        
         elementSearch(arrInclusionB, '[data-inclusions="B"]', objInclusionB);
   });


  $('[data-inclusions="A"] .select__wrap[data-item="ashes"] .select__option').click(function(){
         objInclusionA.ashes = $(this).attr('value');
         elementSearch(arrInclusionA, '[data-inclusions="A"]', objInclusionA);
  });  

  $('[data-inclusions="B"] .select__wrap[data-item="ashes"] .select__option').click(function(){
         objInclusionB.ashes = $(this).attr('value');
         elementSearch(arrInclusionB, '[data-inclusions="B"]', objInclusionB);
  });



  $('[data-inclusions="A"] .select__wrap[data-item="other"] .textarea-btn').click(function(e){
         e.preventDefault();
         changeOther(objInclusionA, $(this));
        elementSearch(arrInclusionA, '[data-inclusions="A"]', objInclusionA);
  });

  $('[data-inclusions="B"] .select__wrap[data-item="other"] .textarea-btn').click(function(e){
         e.preventDefault();
         changeOther(objInclusionB, $(this));
         elementSearch(arrInclusionB, '[data-inclusions="B"]', objInclusionB);
  });








  $('[data-inclusions="A"] .select__wrap[data-item="optional"] .select-item-name').click(function(){
      $('[data-inclusions="A"] .select__wrap[data-item="optional"] .select-checkbox').toggleClass('active');
  });
  $('[data-inclusions="B"] .select__wrap[data-item="optional"] .select-item-name').click(function(){
      $('[data-inclusions="B"] .select__wrap[data-item="optional"] .select-checkbox').toggleClass('active');
  });
 
  
   $('[data-inclusions="A"] .select__wrap[data-item="optional"] .check-item input').change(function(){
        changeOptional(objInclusionA,'[data-inclusions="A"]',$(this),arrInclusionA);
       
   }); 
   $('[data-inclusions="B"] .select__wrap[data-item="optional"] .check-item input').change(function(){
        changeOptional(objInclusionB,'[data-inclusions="B"]',$(this),arrInclusionB);
       
   }); 

 












  

   $('[data-inclusions="A"] .select__wrap[data-item="design"] .select__option').click(function(){
         objInclusionA.design = $(this).attr('value');
        $('.my-product-form__submit-max').removeClass('disable');
         console.log(objInclusionA);
        // showEngreved();
  });
   $('[data-inclusions="B"] .select__wrap[data-item="design"] .select__option').click(function(){
         objInclusionB.design = $(this).attr('value');
        $('.my-product-form__submit-max').removeClass('disable');
         console.log(objInclusionB);
        // showEngreved();
  });




  function addCustomProperties(obj){
   $('.my-custom-property').each(function(){
     if($(this).val() != ''){
       objName = $(this).attr('prop-name');
       obj[objName] = $(this).val();
     }
   });
 }

    function indexGeneral(){
         let arr_nun = [0,1,2,3,4,5,6,7,8,9];
         let arr_en = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
         let arr_EN = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
         let mass = [...arr_en, ...arr_EN,...arr_nun];
         console.log(mass);
         let index = [];
         for(let i = 0; i <= 6; i++){
             let el = mass[Math.floor(Math.random() * mass.length)];
             index.push(el);
         }
         
        return index.join('');
      
    }

 $('.req_input').on('input', function(){
     let fild_count = 0;
     $(this).closest('.input_wrap').css('border','1px solid #FFFFFF');
    $('.req_input').each(function(){
         if($(this).val() != ''){
           fild_count++;
           $(this).closest('.input_wrap').css('border','1px solid #FFFFFF');
         }
     });

     if(objInclusionA.optional != '' || objInclusionB.optional != ' '){
         if(fild_count == $('.req_input').length){
          $('.my-product-form__submit-max').removeClass('disable');
          valid=true;
         }else{
            $('.my-product-form__submit-max').addClass('disable');
             valid=false;
         }
     }
    /* console.log(1);
     
      console.log(fild_count, $('.req_input').length);
   /*  if(fild_count == $('.req_input').length){
        $('.my-product-form__submit').removeClass('disable');
     }else{
        $('.my-product-form__submit').addClass('disable');
     }*/
 
    // validLineItem();
     
   });
  

function validLineItem(){
   let fild_count = 0;
   valid=false
   $('.req_input').each(function(){
         if($(this).val() != ''){
           fild_count++;
           $(this).closest('.input_wrap').css('border','1px solid #FFFFFF');
         }else{
           $(this).closest('.input_wrap').css('border','1px solid #B53E2E');
         }
    });
   /*  console.log(1);
     
      console.log(fild_count, $('.req_input').length);
     if(fild_count == $('.req_input').length){
        $('.my-product-form__submit-max').removeClass('disable');
        valid=true;
     }else{
        $('.my-product-form__submit-max').addClass('disable');
         valid=false;
     }*/
      if(objInclusionA.optional != '' || objInclusionB.optional != ''){
          console.log(7);
         if(fild_count == $('.req_input').length){
          $('.my-product-form__submit-max').removeClass('disable');
          valid=true;
         }else{
             $('.my-product-form__submit-max').addClass('disable');
             $('.inclusions[data-inclusions] .inclusion__body').addClass('active');
             $('.inclusions.display_box .inclusion__body').addClass('active');
             valid=false;
         }
      }else{
        console.log(8);
        $('.inclusions .select__wrap:not(.active)').css('border','1px solid #B53E2E');
        $('.inclusions[data-inclusions] .inclusion__body').addClass('active');
        //$('.inclusions.display_box .inclusion__body').addClass('active');
        $('.inclusions.display_box .inclusion__body').removeClass('active');
        $('.my-product-form__submit-max').addClass('disable');
        valid=false;
      }
 }  

     function handleResponse() {
               let a = this.responseText;
               let parser = new DOMParser();
              //console.log(JSON.parse(this.responseText));
            //  parser.parseFromString(a, "text/html");
             // $('cart-drawer').html(parser.parseFromString(a, "text/html"));
             //   console.log(parser.parseFromString(a, "text/html"));
                let objCarts = JSON.parse(this.responseText);
              //  console.log($(objCarts["cart-drawer"]).find('cart-drawer').html());
                $('#cart-icon-bubble').html($(objCarts["cart-icon-bubble"]).html());
                $('cart-drawer').html($(objCarts["cart-drawer"]).find('cart-drawer').html());
             } 


  
 $('.product .my-product-form__submit-max').click(function(e){
        e.preventDefault();
        validLineItem();
        let inclusionId = $('.inclusion-variant').val();
        $('.product .my-product-form__submit').removeClass('loading');
        console.log($('.select-inclusion option:selected').attr('data-id'), $('.product-variant-id').val());
        let idProduct = indexGeneral();
        let formData = {}  
        let properties = {
           'Size': $('.propert-size').val(),
           'Created for': $('#your-create').val(),
           'In Honor of': $('#your-honor').val(),
           'id-product': idProduct,
           'Inclusions A': objInclusionA.inclusions,
           'Ashes A': objInclusionA.ashes,
           'Other A' : objInclusionA.other,
           'Texture A' : objInclusionA.texture,
           'Optional A': objInclusionA.optional,
           'Design A':   objInclusionA.design,
           'Engraved A': objInclusionA.engraved,
           'Inclusions B': objInclusionB.inclusions,
           'Ashes B': objInclusionB.ashes,
           'Other B' : objInclusionB.other,
           'Texture B' : objInclusionB.texture,
           'Optional B': objInclusionB.optional,
           'Design B':   objInclusionB.design,
           'Engraved B': objInclusionB.engraved,
        };
        addCustomProperties(properties);
        
       
        if(objInclusionA.engraved_item ){
           
           formData = {
              items: [
                   {
                      id:$('.select-inclusion option:selected').attr('data-id'),
                      quantity: $('.quantity__input').val(),
                       properties: {
                        'id-product': 'inclusion-' + idProduct,
                       }
                    },
                   {
                       id:$('.inclusion-variant').val(),
                       quantity: $('.quantity__input').val(),
                       properties: {
                         'id-product': 'engraved-' + idProduct,
                       }
                   },
                   {
                     id:$('.product-variant-id').val(),
                     quantity: $('.quantity__input').val(),
                     properties: ''// properties 
                   }
                   
                   
                   
             ]
           };
        }else{
         
    
            formData = {
                items: [
                  {
                      id:$('.select-inclusion option:selected').attr('data-id'),
                      quantity: $('.quantity__input').val(),
                       properties: {
                        'id-product': 'inclusion-' + idProduct,
                       }
                    },
                    {
                        id:$('.inclusion-variant').val(),
                        quantity: $('.quantity__input').val(),
                        properties: {
                           'id-product': 'engraved-' + idProduct,
                        }
                      } ,
                     {
                       id:$('.product-variant-id').val(),
                       quantity: $('.quantity__input').val(),
                       properties: properties 
                     }
                 
                     
               ]
             };
        }
       
        
       if(valid){
       /*  $(this).addClass('loading');*/
         $(this).find('.loading-overlay__spinner').removeClass('hidden');
         fetch(window.Shopify.routes.root + 'cart/add.js', {
           method: 'POST',
           headers: {
             'Content-Type': 'application/json'
           },
           body: JSON.stringify(formData)
         })
         .then(response => {
 
             const request = new XMLHttpRequest();
             request.addEventListener('load', handleResponse);
             request.open('GET', '?sections=cart-drawer,main-cart-items,cart-icon-bubble', true);///?sections=cart-drawer,
             request.send();
             $('cart-drawer')[0].open();
           return response.json();
         })
         .catch((error) => {
           console.error('Error:', error);
         })
         .finally(function(){
            $('cart-drawer').removeClass('is-empty');
            $('.product .my-product-form__submit').removeClass('loading');
            $('.product .my-product-form__submit-max').find('.loading-overlay__spinner').addClass('hidden');
         });
       }
         
   });

  
});